/**
 * Created by Alan Yang on 5/08/2019.
 * Description:
 * ------ maintenance history ------
 * 06/16/2019 Bowen Li - add tooltip for smart-icon
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

import { WidgetsModule } from '../../widgets/widgets.module';
import { ManageScreensComponent } from './manage-screens.component';
import { ManageScreensCopyButtonComponent } from './manage-screens-copy-button.component';
import { ManageScrerensActionService } from './manage-screen.service';
import { ManageScreensPrivateIconComponent } from './manage-screens-private-icon.component';
import { ManageScreensVisibleButtonComponent } from './manage-screens-visible-button.component';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ManageScreensActionButtonComponent } from './manage-screen-action-button.componment';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AgGridModule,
        DropDownsModule,
        InputsModule,
        WidgetsModule,
        TooltipModule,
    ],
    declarations: [
        ManageScreensComponent,
        ManageScreensCopyButtonComponent,
        ManageScreensActionButtonComponent,
        ManageScreensPrivateIconComponent,
        ManageScreensVisibleButtonComponent
    ],
    providers: [
        ManageScrerensActionService,
    ],
    exports: [
        ManageScreensComponent,
    ]
})
export class ManageScreensModule { }
